import React from 'react';
import {Row} from "reactstrap";
import ViewTable from "app/shared/view-table/view-table";
import {fetchNotificationsOverviewQuery} from "app/modules/notifications/service/notification.queries";
import {paginationKeys} from "app/shared/util/pagination.constants";
import {NotificationRowModel} from "app/modules/notifications/model/notification.model";
import {convertDateTimeFromServer} from "app/shared/util/date-utils";
import ViewTableHeaderColumn from "app/shared/view-table/view-table-header-column";

const NotificationOverview = () => {

  const renderTableRow = (value: NotificationRowModel) => {

    return (
      <tr key={value.idNotification}>
        <td>{convertDateTimeFromServer(value.lastSetActiveDate)}</td>
        <td>{value.title}</td>
        <td>
          <div dangerouslySetInnerHTML={{__html: value.content}} />
        </td>
      </tr>
    )
  }

  return (
    <div className={'container-fluid view-container'}>
      <h3>Obavijesti</h3>
      <Row className={'mt-4'}>
        <ViewTable
          renderTableRow={renderTableRow}
          fetchDataQuery={fetchNotificationsOverviewQuery}
          noDataMessage={'Nema obavijesti.'}
          localStorageKey={paginationKeys.NOTIFICATION_OVERVIEW}
          initialPaginationColumn={'lastSetActiveDate'}
          initialSortDirection={'desc'}
          >
          <ViewTableHeaderColumn renderSort={false} columnLabels={['Datum']} />
          <ViewTableHeaderColumn renderSort={false} columnLabels={['Naslov']} />
          <ViewTableHeaderColumn renderSort={false} width={'66%'} columnLabels={['Sadržaj']} />
        </ViewTable>
      </Row>
    </div>
  );
}

export default NotificationOverview;
